import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ClinicService } from '../../services/clinic.service';
import { PreferencesService } from '../../services/preferences.service';
import { BugReportDialogModule } from '../bug-report-dialog/bug-report-dialog.module';
import { SupportContactDialogModule } from '../support-contact-dialog/support-contact-dialog.module';
import { NotificationModule } from '../notification/notification.module';
import { StatusModule } from '../status/status.module';
import { NavigationComponent } from './navigation.component';
import { PingPacsComponent } from './ping-pacs/ping-pacs.component';
import { PopupNotificationComponent } from './popup-notification/popup-notification.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    NavigationComponent,
    PingPacsComponent,
    PopupNotificationComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    StatusModule,
    NotificationModule,
    MatButtonModule,
    MatBadgeModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatMenuModule,
    MatTooltipModule,
    BugReportDialogModule,
    SupportContactDialogModule,
    FormsModule,
    MatDialogModule,
    MatSnackBarModule,
    RouterModule,
    PipesModule
  ],
  exports: [
    NavigationComponent
  ],
  providers: [
    PreferencesService,
    ClinicService
  ]
})
export class NavigationModule {}
